import React, { useState } from 'react'
import { IconButton, Toolbar, Tooltip, Typography } from "@mui/material"
import { alpha } from '@mui/material/styles';
import TocIcon from '@mui/icons-material/Toc';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import FieldsPicker from './FieldsPicker';

interface ITableHeader {
    displayType?: 'table' | 'chart';
    title?: string;
    fields?: string[];
    setDisplayType: (v: 'table' | 'chart') => void;
    showGraphIcon?: boolean;
    setAxes: (v: {x: string; y: string;}) => void
}

const TableHeader: React.FC<ITableHeader> = ({ displayType = 'table', 
    title = "Result", 
    fields, setDisplayType, 
    showGraphIcon, setAxes }) => {
    const [openFieldPicker, setOpenFieldPicker] = useState(false)
    const Icon = displayType === 'chart' ? <TocIcon /> : <StackedBarChartIcon />
    const newValue = displayType === 'table' ? 'chart' : 'table'

    const handleShowPicker = () => {
        if (displayType === 'table')
            setOpenFieldPicker(true)
        else {
            setOpenFieldPicker(false)
            setDisplayType(newValue)
        }

    }

    return (
        <Toolbar
            sx={{
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                bgcolor: (theme) =>
                    alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
            }}
        >
            <Typography
                sx={{ flex: '1 1 100%' }}
                variant="h6"
                id="tableTitle"
                component="div"
            >
                {title}
            </Typography>
            {showGraphIcon && <Tooltip title="">
                <IconButton onClick={handleShowPicker}>
                    {Icon}
                </IconButton>
            </Tooltip>}
            <FieldsPicker 
                open={openFieldPicker} 
                setOpen={setOpenFieldPicker} 
                fields={fields} 
                setAxes={setAxes}
                setChart={setDisplayType}
                />
        </Toolbar>
    )
}

export default TableHeader